// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"685f5ec9","441":"de87fbd1","495":"80bf86c6","559":"4b712542","690":"a4b982e4","754":"7c1b3cef","854":"d6f31e8a"}[chunkId] + ".chunk.js";
};